import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Dialog from '@mui/material/Dialog';
import Typography from '@mui/material/Typography';
import Alert from '@mui/material/Alert';
import Button from 'components/Button';
import Spin from 'components/Spin';
import toast from 'utils/toast';
import * as authService from 'services/auth.service';
import useRequest from 'hooks/useRequest';
import useQueryParams from 'hooks/useQueryParams';

const OauthLogin = ({}) => {
  const query = useQueryParams();
  const [data, { loading, error }] = useRequest(
    authService.getAuthApp,
    query.client_id,
  );

  const handleSubmit = async () => {
    try {
      const resp = await authService.oauthorize(query);
      window.location.replace(resp.redirect);
    } catch (e) {
      toast.error(e.message);
    }
  };

  return (
    <Dialog open size="sm">
      <Helmet title="OAuth Login" />
      {error && <Alert severity="error">{error}</Alert>}
      {loading && <Spin spinning />}
      {data && (
        <Stack textAlign="center" spacing={3} p={3}>
          <Box mb={2} maxWidth={200} maxHeight={80} mx="auto">
            <img src={data.file_url} className="img-fluid" />
          </Box>
          <Typography variant="h3">
            {data.app_name} wants to access your account.
          </Typography>
          <Typography variant="subtitle1">
            By granting access, {data.app_name} will gain all the same
            permissions to your account as you have.
          </Typography>
          <Typography variant="subtitle1">
            Do you want to allow {data.app_name} access?
          </Typography>
          <Stack direction="row" spacing={2} justifyContent="center">
            <Link to="/">
              <Button variant="text">Cancel</Button>
            </Link>
            <Button size="large" onClick={handleSubmit}>
              Allow
            </Button>
          </Stack>
        </Stack>
      )}
    </Dialog>
  );
};

export default OauthLogin;
